module.exports = __webpack_public_path__ + "static/thumbs-up.efc39d3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/thumbs-up.svg
// module id = 455
// module chunks = 35783957827783 172322841747965